import React, { useState } from 'react';
import IconDots from '../../images/IconDots.jsx';
import IconClose from '../../images/IconClose.jsx';
import { getInitials } from '../../../utils/getInitials.js';

const ProjectContactsListItem = ({ data, onDelete }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);

    const openDrawer = () => {
        setDrawerOpen(true);
    };

    const closeDrawer = () => {
        if (drawerOpen) {
            setDrawerOpen(false);
        }
    };

    const handleDelete = () => {
        onDelete(data.contact_id ?? data.tempId);
    };

    return (
        <>
            <div className='relative overflow-hidden mt-2'>
                <div className='flex flex-col max-w-3xl w-full mx-auto' onClick={closeDrawer}>
                    <div className='flex'>
                        <div className='rounded-full w-[48px] h-[48px] overflow-hidden mr-[16px] flex items-center justify-center bg-theme1-pale text-theme1-primary font-bold'>
                            {getInitials([data.first_name, data.last_name].filter(Boolean).join(' '))}
                        </div>
                        <div className='flex flex-1 items-center border-b border-solid border-theme1-tanTransparent pb-2'>
                            <div>
                                <div className={'flex'}>
                                    <div className='text-base text-theme1-title2 font-bold'>
                                        {[data.first_name, data.last_name].filter(Boolean).join(' ')}
                                    </div>
                                    {data.is_lead && (
                                        <div
                                            className={`w-min ml-2 content-center px-3 rounded-md text-[13px] font-bold text-white capitalize bg-theme1-info`}
                                        >
                                            Lead
                                        </div>
                                    )}
                                </div>
                                {data.email && <div className='text-sm text-theme1-text1'>{data.email}</div>}
                            </div>
                            <button type='button' className='ml-auto' onClick={openDrawer}>
                                <IconDots className='fill-theme1-text1' />
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    className={`absolute flex gap-[2px] top-0 right-0 h-full bg-white transform transition-transform duration-300 ${
                        drawerOpen ? 'translate-x-0 shadow-lg' : 'translate-x-full'
                    }`}
                >
                    <button
                        className='w-[72px] flex-shrink-0 bg-theme1-primary py-2 rounded-[2px] flex items-center justify-center active:bg-theme1-brightRed'
                        onClick={handleDelete}
                    >
                        <IconClose className='fill-white w-[38px] h-[33px]' />
                    </button>
                </div>
            </div>
        </>
    );
};

export default ProjectContactsListItem;
